import {
  Inject,
  Injectable,
  InjectionToken,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthStatus } from '../types/interfaces/auth-status';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { isPlatformServer } from '@angular/common';
import { Request } from 'express';
import { LoginResponse } from '../types/interfaces/login-response';
import { Tenant } from '../types/interfaces/tenant';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private store: Store,
    private httpClient: HttpClient,
    private cookieService: SsrCookieService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  login(user: string, password: string): Observable<LoginResponse> {
    return this.httpClient.post<LoginResponse>(
      `${environment.apiHost}/auth/login`,
      {
        user,
        password,
      },
      {
        withCredentials: true,
      }
    );
  }

  logout(): Observable<object> {
    return this.httpClient.post(`${environment.apiHost}/auth/logout`, null, {
      withCredentials: true,
    });
  }

  isAuthenticated(): Observable<AuthStatus> {
    if (isPlatformServer(this.platformId)) {
      const req = inject(new InjectionToken<Request>('REQUEST'));
      console.log(req);
      console.log(`COOKIE: ${this.cookieService.get('connect.sid')}`);

      return this.httpClient.get<AuthStatus>(
        `${environment.apiHost}/auth/status`,
        {
          withCredentials: true,
          headers: {
            cookie: this.cookieService.get('connect.sid'),
          },
        }
      );
    } else {
      return this.httpClient.get<AuthStatus>(
        `${environment.apiHost}/auth/status`,
        {
          withCredentials: true,
        }
      );
    }
  }

  getSessionTenant(): Observable<Tenant> {
    return this.httpClient.get<Tenant>(`${environment.apiHost}/auth/tenant`, {
      withCredentials: true,
    });
  }
}
